module.exports = __webpack_public_path__ + "static/media/Icon_x.417cd83b.svg";